



























import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from 'vuex-class'
import SFKnob from '@/components/SFKnob.vue';
import {ProgressFooter, SFPreloader} from '@/components';

import t from '@/i18n/translations';

import report from '@/api/report';

@Component({
    components: {
    },
})
export default class ReportGenerated extends Vue {
    selectedBranchID: string = '';
    i18n = t['nl'];

    mounted(): void {
        setTimeout(() => {
            this.$router.push('/list');
        }, 3000);
    }

}
